/* eslint-disable no-irregular-whitespace */
import { Pipe, PipeTransform } from '@angular/core';
import { MONEY_SYMBOL } from '@shared/constants/money-format.const';

export interface CustomerCurrencyOptions {
  symbol?: string;
  thousandsSeparator?: string;
  decimalSeparator?: string;
  locale?: 'vi-VN' | 'en-US';
  maxDecimalPlaces?: number;
}

@Pipe({
  name: 'ccurrency'
})
export class CustomCurrencyPipe implements PipeTransform {
  private localeToDecimalPlaces = {
    'vi-VN': 0,
    'en-US': 0
  };

  transform(value: number | string | null | undefined, options: CustomerCurrencyOptions = {}): string {
    const {
      symbol = MONEY_SYMBOL,
      locale = 'vi-VN',
      thousandsSeparator = locale === 'vi-VN' ? '.' : ',',
      decimalSeparator = locale === 'vi-VN' ? ',' : '.',
      maxDecimalPlaces
    } = options;

    let numValue: number;
    if (typeof value === 'string') {
      let clean = value.trim();
      if (clean.includes('.') && clean.includes(',')) {
        if (clean.lastIndexOf(',') > clean.lastIndexOf('.')) {
          // Vietnamese format: 1.234,56
          clean = clean.replace(/\./g, '').replace(',', '.');
        } else {
          // US format: 1,234.56
          clean = clean.replace(/,/g, '');
        }
      } else if (clean.includes(',')) {
        clean = clean.replace(',', '.');
      }
      numValue = parseFloat(clean);
    } else {
      numValue = value != null ? Number(value) : 0;
    }

    if (isNaN(numValue)) return '-';

    const sign = numValue < 0 ? '-' : '';
    const decimalPlaces = maxDecimalPlaces ?? this.localeToDecimalPlaces[locale];
    const [integerPart, decimalPart = ''] = Math.abs(numValue).toFixed(decimalPlaces).split('.');
    const groupedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
    // Trailing zeros are dropped so whole amounts keep the compact form they had before decimals were allowed
    const significantDecimal = decimalPart.replace(/0+$/, '');
    const formated = significantDecimal ? `${groupedInteger}${decimalSeparator}${significantDecimal}` : groupedInteger;

    const tranformedValueBaseonLocale = {
      'vi-VN': `${sign}${formated} ${symbol}`,
      'en-US': `${sign}${symbol}${formated}`
    };

    return tranformedValueBaseonLocale[locale];
  }
}
